import React from 'react';
import { StyledBarSpinner } from './BarSpinner.styles';
export function BarSpinner(props) {
    const { className, id, width = '100%' } = props;
    return (React.createElement(StyledBarSpinner, { className: className, "data-cy": props['data-cy'], id: id, style: { width } },
        React.createElement("span", null)));
}
//# sourceMappingURL=BarSpinner.js.map